import { __decorate as t, __classPrivateFieldGet as e, __classPrivateFieldSet as i } from "tslib";
import { LitElement as s, svg as r } from "lit";
import { property as h, state as o } from "lit/decorators.js";
import { generateId as l } from "../../utilities/utils.js";
import n from "./icon-styles.js";
var a, p, c, d, u, g, m, f, w, y;
class I extends s {
  constructor() {
    super(...arguments), a.set(this, ""), p.set(this, -1), c.set(this, "var(--IDS-ICON__COLOR)"), d.set(this, "var(--IDS-ICON__COLOR-2)"), u.set(this, "m"), g.set(this, ""), m.set(this, ""), f.set(this, ""), w.set(this, !1), y.set(this, !1), this.titleId = l(), this.medium = {
      height: "2.5rem",
      width: "2.5rem"
    }, this.small = {
      height: "1.25rem",
      width: "1.25rem"
    }, this.xsmall = {
      height: "0.75rem",
      width: "0.75rem"
    }, this.vbHeight = 0, this.vbWidth = 0;
  }
  get title() {
    return e(this, a, "f");
  }
  set title(t) {
    i(this, a, t, "f");
  }
  get colorpreset() {
    return e(this, p, "f");
  }
  set colorpreset(t) {
    i(this, p, t, "f");
  }
  get color() {
    return e(this, c, "f");
  }
  set color(t) {
    i(this, c, t, "f");
  }
  get color2() {
    return e(this, d, "f");
  }
  set color2(t) {
    i(this, d, t, "f");
  }
  get size() {
    return e(this, u, "f");
  }
  set size(t) {
    i(this, u, t, "f");
  }
  get width() {
    return e(this, g, "f");
  }
  set width(t) {
    i(this, g, t, "f");
  }
  get height() {
    return e(this, m, "f");
  }
  set height(t) {
    i(this, m, t, "f");
  }
  get rotate() {
    return e(this, f, "f");
  }
  set rotate(t) {
    i(this, f, t, "f");
  }
  get inline() {
    return e(this, w, "f");
  }
  set inline(t) {
    i(this, w, t, "f");
  }
  get isDisabled() {
    return e(this, y, "f");
  }
  set isDisabled(t) {
    i(this, y, t, "f");
  }
  get dimensions() {
    if (this.width && this.height) return {
      width: this.width,
      height: this.height
    };
    switch (this.size) {
      case "xs":
        return this.xsmall;
      case "s":
      default:
        return this.small;
      case "m":
        return this.medium;
    }
  }
  getDimensions() {
    if (this.width && this.height) return {
      width: this.width,
      height: this.height
    };
    switch (this.size) {
      case "xs":
        return this.xsmall;
      case "s":
      default:
        return this.small;
      case "m":
        return this.medium;
    }
  }
  get colors() {
    if (this.isDisabled) return {
      color: "var(--IDS-INPUT--DISABLED__ICON-FILL)",
      color2: "var(--IDS-INPUT--DISABLED__ICON-FILL)"
    };
    const t = {
      color: this.color,
      color2: this.color2
    };
    return !isNaN(this.colorpreset) && this.colorpreset > 0 && (t.color = `var(--IDS-ICON__COLOR-PRESET-${this.colorpreset})`, t.color2 = `var(--IDS-ICON__COLOR-PRESET-${this.colorpreset}-2)`), t;
  }
  connectedCallback() {
    super.connectedCallback(), this.classList.add("ids-icon");
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.createTitle();
  }
  createTitle() {
    if (this.title) {
      const t = document.createElement("title");
      t.setAttribute("id", this.titleId), t.textContent = `${this.title}`, this.shadowRoot.querySelector("svg").prepend(t), this.shadowRoot.querySelector("svg").setAttribute("aria-labelledby", this.titleId);
    } else this.shadowRoot.querySelector("svg").setAttribute("aria-hidden", "true");
  }
  renderIcon() {
    return r``;
  }
  render() {
    return r`<svg xmlns="http://www.w3.org/2000/svg" role="img" width="${this.dimensions.width}" height="${this.dimensions.height}" style="${this.rotate ? `rotate: ${this.rotate}deg` : null}" viewBox="0 0 ${this.vbWidth} ${this.vbHeight}" fill="none">${this.renderIcon()}</svg>`;
  }
}
a = new WeakMap(), p = new WeakMap(), c = new WeakMap(), d = new WeakMap(), u = new WeakMap(), g = new WeakMap(), m = new WeakMap(), f = new WeakMap(), w = new WeakMap(), y = new WeakMap(), I.styles = [n], t([h({
  type: String
})], I.prototype, "title", null), t([h({
  type: Number
})], I.prototype, "colorpreset", null), t([h({
  type: String
})], I.prototype, "color", null), t([h({
  type: String
})], I.prototype, "color2", null), t([h({
  type: String,
  reflect: !0
})], I.prototype, "size", null), t([h({
  type: String
})], I.prototype, "width", null), t([h({
  type: String
})], I.prototype, "height", null), t([h({
  type: String
})], I.prototype, "rotate", null), t([h({
  type: Boolean,
  reflect: !0
})], I.prototype, "inline", null), t([o()], I.prototype, "isDisabled", null);
export { I as IDSIconBase };